export function formatAuthError(error: unknown): string {
  if (!(error instanceof Error)) {
    return '処理に失敗しました'
  }

  const name = error.name
  const message = error.message

  switch (name) {
    case 'UsernameExistsException':
      return 'このメールアドレスは既に登録されています。ログインしてください。'
    case 'InvalidPasswordException':
      return 'パスワードがポリシーを満たしていません（8文字以上・大文字・小文字・数字・記号）。'
    case 'CodeMismatchException':
      return '確認コードが正しくありません。'
    case 'ExpiredCodeException':
      return '確認コードの有効期限が切れました。サインアップからやり直してください。'
    case 'UserNotConfirmedException':
      return 'メール確認が完了していません。確認コードを入力してください。'
    case 'NotAuthorizedException':
      return 'メールアドレスまたはパスワードが正しくありません。'
    case 'UserNotFoundException':
      return 'アカウントが見つかりません。サインアップしてください。'
    case 'LimitExceededException':
      return '試行回数が多すぎます。しばらく待ってから再試行してください。'
    case 'UserAlreadyAuthenticatedException':
      return 'セッションの引き継ぎに失敗しました。お手数ですが、もう一度お試しください。'
    default:
      return message || '処理に失敗しました'
  }
}

export const PASSWORD_POLICY_HINT =
  '8文字以上、大文字・小文字・数字・記号をそれぞれ1文字以上含めてください。'
